import { render, staticRenderFns } from "./UserGroupContainer.vue?vue&type=template&id=c01eca7e&scoped=true&"
import script from "./UserGroupContainer.vue?vue&type=script&lang=js&"
export * from "./UserGroupContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserGroupContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserGroupContainer.vue?vue&type=style&index=1&id=c01eca7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01eca7e",
  null
  
)

export default component.exports